const name = 'customReports';
const path = 'reports/yard/volume';

export default {
  get: {
    name,
    path
  }
};
